import { useState, useEffect } from "react";

const WelcomeModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasSeenWelcome = localStorage.getItem("hasSeenWelcomeModal");
    if (!hasSeenWelcome) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem("hasSeenWelcomeModal", "true");
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    // background overlay
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="relative w-full max-w-lg bg-white rounded-lg shadow-xl dark:bg-gray-800 dark:border dark:border-gray-700">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b rounded-t dark:border-gray-700">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
            Welcome to my SuperApp!
          </h3>
          <button
            onClick={handleClose}
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
            <strong>Work in Progress:</strong> This web app is a personal learning and challenge
            project built to see how many full-stack features I can successfully implement from
            scratch.
          </p>
          <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
            The complete source code is publicly available on my GitLab for review. Because this is
            a demonstration environment, please{" "}
            <strong>do not input any sensitive or real personal information</strong> (like real
            passwords or financial data).
          </p>
          <p className="text-base font-medium leading-relaxed text-gray-700 dark:text-gray-300">
            Otherwise, feel free to poke around, break things, and enjoy the website!
          </p>
        </div>

        {/* Footer */}
        <div className="flex items-center p-4 border-t border-gray-200 rounded-b dark:border-gray-700">
          <button
            onClick={handleClose}
            className="w-full text-white bg-lightGreen hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
          >
            I understand, let's go!
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
